<template>
    <tr
        :class="`vehicle-dashboard
        ${isSelected ? 'vehicle-selected' : ''}`"
        v-bind:style="isSelected ? ['background: rgba(26, 160, 225, 0.10)'] : ['']"
        role="row"
    >
        <td v-if="['3', '4', '5'].includes(orderStatus)" class="vehicle-checkbox">
            <div class="checkbox">
                <label>
                    <input
                        :disabled="!isSelectionAllowed"
                        @change="selectCar"
                        type="checkbox"
                        v-bind:checked="isSelected"
                    />
                    <i
                        :style="
                            !isSelectionAllowed
                                ? 'background: transparent; cursor: not-allowed'
                                : isSelected
                                ? ''
                                : 'background: white'
                        "
                    />
                </label>
            </div>
        </td>
        <td
            v-if="orderStatus === 'on_order' || orderStatus === '2'"
            class="dashboard__table-td c-size-190"
        >
            <div>
                <button class="on-order-button">
                    <i18n-t keypath="myOrders.onOrder" />
                </button>
            </div>
        </td>
        <td
            v-if="orderStatus === 'to_pay' || orderStatus === '3'"
            class="dashboard__table-td c+size-190"
        >
            <div>
                <button disabled class="to-pay-status">
                    {{ orderVehicle.status.name }}
                </button>
                <div v-if="isAwaitingPayment">
                    <div>
                        <span class="status-text">
                            <i18n-t keypath="myOrders.prePaid" />
                            :
                        </span>
                    </div>
                    <div>
                        <span class="status-text">
                            <app-format-currency
                                :value="payments?.amount_paid_confirmed"
                                currency="EUR"
                            />
                        </span>
                    </div>
                </div>
            </div>
        </td>
        <td
            v-if="orderStatus === 'to_transport' || orderStatus === '4'"
            class="dashboard__table-td c+size-190"
        >
            <div class="transport-status-container">
                <div class="transport-status-button">{{ orderVehicle.status.name }}</div>
            </div>
            <div style="margin-top: 1px">
                <div v-if="orderStatus.id === 'transport'">
                    <span class="status-text">{{ orderStatus.name }}: 7</span>
                </div>
            </div>
        </td>
        <td
            v-if="orderStatus === 'processing_documents' || orderStatus === '5'"
            class="dashboard__table-td c+size-190"
        >
            <div class="dashboard__table-column vehicle-column">
                <div class="processing-documents-button">
                    {{ orderVehicle.status.name }}
                </div>
                <span
                    v-if="orderVehicle.status.id === 15"
                    class="processing-documents-details"
                >
                    <i18n-t keypath="myOrders.verifying" />
                </span>
                <span
                    v-if="orderVehicle.status.id === 13"
                    class="processing-documents-details"
                >
                    <i18n-t keypath="myOrders.afterReceived" />
                </span>
                <span
                    v-if="orderVehicle.status.id === 16"
                    class="processing-documents-details"
                >
                    <i18n-t keypath="myOrders.shippingDocuments" />
                </span>
            </div>
        </td>
        <td
            v-if="orderStatus === 'completed' || orderStatus === '6'"
            class="dashboard__table-td c+size-190"
        >
            <div class="dashboard__table-column vehicle-column">
                <button disabled class="completed-button">
                    <i18n-t keypath="myOrders.completed.title" />
                </button>
                <span class="status-text delivery-date-span">
                    <b>
                        <i18n-t keypath="myOrders.completed.description" />
                        :
                    </b>
                    {{ formatDate(order.date) }}
                </span>
                <span class="status-text">
                    <b>Payment Received:</b>
                    {{ formatDate(order.date) }}
                </span>
                <span class="status-text">
                    <b>CMR:</b>
                    {{ formatDate(order.date) }}
                </span>
            </div>
        </td>
        <td class="dashboard__table-td c+size-161">
            <div class="dashboard__popup-item dashboard__carInfo-item c-orders-item-line">
                <div
                    style="
                        display: flex;
                        flex-direction: column;
                        justify-content: flex-start;
                        align-items: flex-start;
                    "
                >
                    <div style="width: 136px">
                        <span
                            style="
                                color: #283747;
                                font-size: 12px;
                                font-family: var(--font-family);
                                font-weight: 600;
                                line-height: 19px;
                                word-wrap: break-word;
                            "
                        >
                            <i18n-t keypath="myOrders.carAvailability" />
                            :
                        </span>
                        <span
                            style="
                                color: #283747;
                                font-size: 12px;
                                font-family: var(--font-family);
                                font-weight: 400;
                                line-height: 19px;
                                word-wrap: break-word;
                            "
                        >
                            {{
                                orderVehicle?.availability?.name?.includes("Stock")
                                    ? i18n.t("myOrders.Stock")
                                    : i18n.t("myOrders.notAvailable")
                            }}
                        </span>
                    </div>
                    <div
                        style="
                            color: #283747;
                            font-size: 12px;
                            font-family: var(--font-family);
                            font-weight: 600;
                            line-height: 19px;
                            word-wrap: break-word;
                        "
                    >
                        <i18n-t keypath="myOrders.documentAvailability" />
                    </div>
                    <div>
                        <span
                            style="
                                color: #283747;
                                font-size: 12px;
                                font-family: var(--font-family);
                                font-weight: 600;
                                word-wrap: break-word;
                            "
                        >
                            <i18n-t keypath="myOrders.COC" />
                            :
                        </span>
                        <span
                            style="
                                color: #283747;
                                font-size: 12px;
                                font-family: var(--font-family);
                                font-weight: 400;
                                word-wrap: break-word;
                            "
                        >
                            {{
                                isCocAvailable
                                    ? i18n.t("myOrders.available")
                                    : i18n.t("myOrders.NA")
                            }}
                        </span>
                    </div>
                    <div>
                        <span
                            style="
                                color: #283747;
                                font-size: 12px;
                                font-family: var(--font-family);
                                font-weight: 600;
                                word-wrap: break-word;
                            "
                        >
                            <i18n-t keypath="myOrders.REG" />
                            :
                        </span>
                        <span
                            style="
                                color: #283747;
                                font-size: 12px;
                                font-family: var(--font-family);
                                font-weight: 400;
                                word-wrap: break-word;
                            "
                        >
                            {{
                                isRegAvailable
                                    ? i18n.t("myOrders.available")
                                    : i18n.t("myOrders.NA")
                            }}
                        </span>
                    </div>
                </div>
            </div>
        </td>
        <!-- <td
            v-if="['1', '2', 'on_order', 'to_approve'].includes(orderStatus)"
            class="dashboard__table-td c+size-190"
        >
            <div
                class="dashboard__popup-item dashboard__carInfo-item c-orders-item-line"
            ></div>
        </td> -->
        <td class="dashboard__table-td dashboard__table-td c+size-345">
            <div
                class="dashboard__popup-item dashboard__carInfo-item c-orders-item-line"
                style="border: none"
            >
                <div class="car-preview-container">
                    <img
                        v-if="orderVehicle.thumbnail_image?.href_small"
                        :src="orderVehicle.thumbnail_image?.href_small"
                    />
                    <div class="no-image-block" :class="isAstara ? 'astara': ''" v-else>
                        <img width="80" height="60" :src="`/img/${brandLabel}/no-image.svg`"/>
                    </div>
                </div>
                <div class="dashboard__carInfo-info">
                    <div class="car-model-info">
                        {{
                            orderVehicle.vehicle.brand.name +
                            " " +
                            orderVehicle.vehicle.model +
                            " " +
                            orderVehicle.vehicle.finish +
                            " " +
                            orderVehicle.vehicle.powertrain.gearbox.name +
                            " " +
                            orderVehicle.vehicle.powertrain.fueltype.name
                        }}
                    </div>
                    <div class="car-specs">
                        {{ orderVehicle.vehicle.powertrain.motorisation }}
                        <br />
                        {{ orderVehicle.vehicle.color_factory }}
                        <br />
                        {{
                            orderVehicle.vehicle.powertrain.power_hp +
                            " hp (" +
                            orderVehicle.vehicle.powertrain.power_kw +
                            " kw)"
                        }}
                    </div>
                    <div class="additional-details" style="display: table-column">
                        <span class="label">
                            <i18n-t keypath="carDetails.ID" />
                            :
                        </span>
                        <span>{{ orderVehicle.vehicle.id }}</span>
                        <div v-if="orderVehicle?.vehicle_vin">
                            <span class="label">
                                <i18n-t keypath="carDetails.VIN" />
                                :
                            </span>
                            <span>{{ orderVehicle.vehicle_vin }}</span>
                            <br />
                        </div>
                    </div>
                </div>
            </div>
        </td>
        <td class="dashboard__table-td dashboard__table-td c+size-220 order-info-label">
            <div>
                <p v-if="orderVehicle.vehicle?.condition.name">
                    <span class="label">
                        <i18n-t keypath="carDetails.condition" />
                        :
                    </span>
                    {{ orderVehicle.vehicle?.condition.name }}
                </p>
                <p v-if="orderVehicle.vehicle?.mileage">
                    <span class="label">
                        <i18n-t keypath="carDetails.mileage" />
                        :
                    </span>
                    {{ orderVehicle.vehicle?.mileage }}
                </p>
                <p v-if="orderVehicle.vehicle?.firstregistration_date">
                    <span class="label">
                        <i18n-t keypath="carDetails.firstregistration_date" />
                        :
                    </span>
                    {{ formatDate(orderVehicle.vehicle.firstregistration_date) }}
                </p>
                <p>
                    <span class="label">
                        <i18n-t keypath="carDetails.color" />
                        :
                    </span>
                    {{
                        `${orderVehicle.vehicle.color.name} (Ext: ${
                            orderVehicle.vehicle.color_factory
                        }${
                            orderVehicle.vehicle.color_interior_factory
                                ? " / Int: " + orderVehicle.vehicle.color_interior_factory
                                : ""
                        })`
                    }}
                </p>
                <p v-if="orderVehicle.vehicle?.powertrain?.gearbox?.name">
                    <span class="label">
                        <i18n-t keypath="carDetails.gearbox" />
                        :
                    </span>
                    {{ orderVehicle.vehicle?.powertrain?.gearbox?.name }}
                </p>
                <p v-if="orderVehicle.vehicle?.powertrain?.drivetrain?.name">
                    <span class="label">
                        <i18n-t keypath="carDetails.drivetrain" />
                        :
                    </span>
                    {{ orderVehicle.vehicle?.powertrain?.drivetrain?.name }}
                </p>
                <p v-if="orderVehicle.vehicle?.powertrain?.fueltype?.name">
                    <span class="label">
                        <i18n-t keypath="carDetails.fueltype" />
                        :
                    </span>
                    {{ orderVehicle.vehicle?.powertrain?.fueltype?.name }}
                </p>
            </div>
        </td>
        <td class="dashboard__table-td dashboard__table-td c+size-220">
            <div class="c-orders-item-line-last" />
            <div class="dashboard__popup-column dashboard__popup-price c-price-details">
                <div class="dashboard__popup-priceBlock">
                    <strong><i18n-t keypath="cart.vehicle" /></strong>
                    <strong class="text-right">
                        <app-format-currency
                            :value="orderVehicle?.price_vehicle_ex_vat ?? 0"
                            :currency="order?.currency"
                        ></app-format-currency>
                    </strong>
                </div>
                <div class="dashboard__popup-priceBlock">
                    <strong>
                        <i18n-t keypath="cart.feeTransport" />
                    </strong>
                    <strong class="text-right">
                        <app-format-currency
                            :value="orderVehicle?.price_transport_ex_vat ?? 0"
                            :currency="order?.currency"
                        ></app-format-currency>
                    </strong>
                </div>
                <div class="dashboard__popup-priceBlock">
                    <strong>
                        <i18n-t keypath="cart.feeAdministration" />
                    </strong>
                    <strong
                        class="text-right"
                        v-if="orderVehicle?.price_admin_handling_ex_vat != undefined"
                    >
                        <app-format-currency
                            :value="orderVehicle?.price_admin_handling_ex_vat ?? 0"
                            currency="EUR"
                        ></app-format-currency>
                    </strong>
                    <strong class="text-right" v-else>TBD</strong>
                </div>
                <div class="dashboard__popup-priceBlock">
                    <strong>
                        <i18n-t keypath="cart.vat" />
                    </strong>
                    <strong
                        class="text-right"
                        v-if="orderVehicle?.vat_amount != undefined"
                    >
                        <app-format-currency
                            :value="orderVehicle?.vat_amount ?? 0"
                            currency="EUR"
                        ></app-format-currency>
                    </strong>
                    <strong class="text-right" v-else>TBD</strong>
                </div>
                <div class="dashboard__popup-priceBlock">
                    <strong>
                        <i18n-t keypath="cart.dealReduction" />
                    </strong>
                    <strong class="text-right">
                        <app-format-currency
                            :value="(orderVehicle?.deal_reduction > 0 ? -orderVehicle?.deal_reduction : 0)"
                            currency="EUR"
                        ></app-format-currency>
                    </strong>
                </div>
                <div class="line"></div>
                <hr style="width: 100%; background: #283747" />
                <div class="dashboard__popup-priceBlock">
                    <strong>
                        <i18n-t keypath="cart.subtotal" />
                    </strong>
                    <strong class="text-right">
                        <app-format-currency
                            v-if="!isOrderWithTBD"
                            :value="Number(orderVehicle.total_price_including_vat)"
                            :currency="order?.currency"
                        ></app-format-currency>
                        <template v-else>TBD</template>
                    </strong>
                </div>
            </div>
        </td>
        <td class="dashboard__table-td dashboard__table-td c+size-142">
            <div class="dashboard__table-column vehicle-column">
                <template v-if="true">
                    <button
                        v-if="
                            ((orderStatus === String('to_pay') || orderStatus === '3') &&
                                showPayment) ||
                            isProcessingPayment
                        "
                        class="dashboard__table-btn width__full btn__light_blue"
                        type="button"
                        @click="() => (showPayPopup = true)"
                    >
                        <i18n-t keypath="myOrders.pay" />
                    </button>
                    <confirm-date-popup
                        v-if="showConfirmPopup"
                        v-model:_vehiclesId="currentVehicleIdAsList"
                        v-model:_order="order"
                        v-model:_formattedDate="formattedSelectedDate"
                        @closeConfirmPopup="closeConfirmPopup"
                    />
                    <div
                        v-if="
                            (orderStatus === 'to_transport' || orderStatus === '4') &&
                            isCheckboxToTransport
                        "
                        style="width: 100%; user-select: none"
                    >
                        <p-calendar
                            style="position: absolute; opacity: 0; height: 1.875rem"
                            id="range"
                            :min-date="new Date(Date.now() + 48 * 60 * 60 * 1000)"
                            :max-date="new Date(Date.now() + 15 * 24 * 60 * 60 * 1000)"
                            :input-style="'cursor: pointer'"
                            dateFormat="dd/mm/yy"
                            selectionMode="range"
                            v-if="showDatePicker"
                            :manualInput="false"
                            @update:modelValue="handleDateSelected"
                        />
                        <button
                            class="dashboard__table-btn width__full btn__blue"
                            type="button"
                            @click="getDatePicker"
                        >
                            <i18n-t keypath="myOrders.pickupDate" />
                        </button>
                    </div>
                    <button
                        v-if="
                            (orderStatus === 'processing_documents' ||
                                orderStatus === '5') &&
                            (orderVehicle.status.id === 13 ||
                                orderVehicle.status.id === 14)
                        "
                        class="dashboard__table-btn width__full btn__yellow"
                        type="button"
                        @click="() => (showUploadCrmPopup = true)"
                    >
                        <i18n-t keypath="myOrders.uploadCMR" />
                    </button>
                    <DeclinePopup v-if="isPopupOpen" @click="closePopup" />
                </template>
                <template
                    v-if="orderStatus === 'on_order' || orderStatus === '2'"
                ></template>

                <template
                    v-else-if="
                        isOrderInStatus(orderStatusEnum.processing_documents) &&
                        (isOrderInSubStatus(orderSubStatusEnum.waiting_cmr) ||
                            isOrderInSubStatus(orderSubStatusEnum.cmr_overdue))
                    "
                >
                    <button
                        class="dashboard__table-btn"
                        type="button"
                        @click="() => (showUploadCmr = true)"
                    >
                        <i18n-t keypath="myOrders.uploadCMR" />
                    </button>
                </template>

                <a v-if="!((orderStatus === 'to_transport' || orderStatus === '4') &&
                            isCheckboxToTransport)" class="dashboard__table-link" @click.prevent="downloadZipByImageId" :disabled="downloadingImages" style="width: 100%; display: flex; justify-content: center; align-items: center;">
                        <span v-if="downloadingImages" class="p-button-loading-icon pi pi-spinner pi-spin"></span>
                        <template v-else>
                            <img width="18" height="18" src="/img/list.svg" alt="#" />
                            <span style="margin-left: 12px">
                                <i18n-t keypath="myOrders.downloadImages" />
                            </span>
                        </template>
                </a>

                <router-link
                    v-if="orderStatus === 'to_pay' || orderStatus === '3'"
                    class="dashboard__table-link"
                    to=""
                    @click="openPaymentsTransactionsPopup(order.id)"
                >
                    <img width="18" height="18" src="/img/payment.svg" alt="#" />
                    <span style="margin-left: 12px">
                        <i18n-t keypath="myOrders.viewPayment" />
                    </span>
                </router-link>
                <template
                    v-if="
                        orderStatus === 'to_transport' || orderStatus === '4'
                        // isOrderInStatus(orderStatusEnum.to_transport) &&
                        // isOrderInSubStatus(orderSubStatusEnum.ready_for_pickup)
                    "
                >
                    <span class="c-pickup-hours-label">
                        <b><i18n-t keypath="myOrders.pickupHours" /></b>
                        08:00 - 16:00
                    </span>
                    <p-calendar
                            style="position: absolute; opacity: 0; height: 1.875rem"
                            id="range"
                            :min-date="new Date(Date.now() + 48 * 60 * 60 * 1000)"
                            :max-date="new Date(Date.now() + 15 * 24 * 60 * 60 * 1000)"
                            :input-style="'cursor: pointer'"
                            dateFormat="dd/mm/yy"
                            selectionMode="range"
                            v-if="showDatePicker"
                            :manualInput="false"
                            @update:modelValue="handleDateSelected"
                        />
                    <button
                            v-if="!isCheckboxToTransport"
                            class="dashboard__table-btn width__full btn__blue pickup-date-button"
                            type="button"
                            @click="getDatePicker"
                        >
                            <i18n-t keypath="myOrders.pickupDate" />
                        </button>
                </template>
            </div>
            <div
                class="dashboard__table-badge table-badge"
                :class="
                    order.type.id === 1 ? 'table-badge--online' : 'table-badge--offline'
                "
            >
                <svg class="sprite-icon dashboard__table-icon" width="12" height="12">
                    <use xlink:href="/img/sprite.svg#icon-credit"></use>
                </svg>
                <span class="table-badge__text">
                    {{ order.type.id === 1 ? "online" : "key account" }}
                </span>
            </div>
        </td>
    </tr>
    <manual-transfer-popup
        @close="() => (showPayPopup = false)"
        v-if="showPayPopup"
        v-model:_orderId="order.id"
        v-model:_vehiclesId="currentVehicleIdAsList"
        v-model:_isProcessingPayment="isProcessingPayment"
    />
    <upload-cmr-popup
        @closePopup="() => (showUploadCrmPopup = false)"
        v-if="showUploadCrmPopup"
        v-model:_orderId="order.id"
        v-model:_vehiclesId="currentVehicleIdAsList"
    ></upload-cmr-popup>
</template>

<script lang="ts">
import { OrderVehicleItem } from "@/dashboard/my-orders/orders-table/table-item/order-vehicle-item";

export default OrderVehicleItem;
</script>
<style scoped lang="scss">
@import "public/css/utils/vars.scss";
@import "public/css/utils/mixins.scss";
@import "public/css/utils/utils.scss";
.width__full {
    width: 100%;
}

.btn__light_blue {
    background: var(--color-green);
}

.btn__blue {
    background: rgba(91, 114, 218, 1);
}

.btn__yellow {
    background: rgba(249, 198, 17, 1);
}

.order-sidebar-header {
    /* Paragraph Medium */
    font-family: var(--font-family);
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 26px;
    color: #627690;
}

.order-sidebar-total {
    font-family: var(--font-family);
    font-style: normal;
    font-weight: 400;
    font-size: 13px;
    line-height: 18px;
    color: #283747;
}

.order-sidebar-total-price {
    color: #ff4545;
}

.order-pay-title {
    font-family: var(--font-family);
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 26px;
    color: #283747;
}

.order-pay-description {
    margin-top: 15px;
    padding: 15px 15px 1px 34px;
    background: #e4eaf0;
    opacity: 0.5;
    border-radius: 4px;
    text-align: left;
}

.dashboard__table {
    border-collapse: collapse;
}

.order-pay-description span {
    font-family: var(--font-family);
    font-style: normal;
    font-size: 13px;
    line-height: 20px;
    color: #4e627c;
    font-weight: normal;
    margin-bottom: 5px;
}

.order-pay-txt-list-item {
    display: list-item;
}

.order-pay-manual-txt {
    font-family: var(--font-family);
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 26px;
    text-align: center;
    color: #627690;
}

.dashboard__table-column {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.pickup-date-button {
   margin-top: 10px;
}

.car-info-details {
    flex: 1;
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 5px;
}

.car-model-info {
    font-size: 15px;
    font-weight: 600;
    color: #283747;
}

.car-specs,
.additional-details {
    font-size: 12px;
    line-height: 18px;
    color: #283747;
}

.additional-details {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 10px;
}

.label {
    font-weight: 600;
    margin-right: 5px;
}

.to-approve-button {
    height: 24px;
    border-radius: 4px;
    border: 1px solid rgba(255, 69, 69, 1);
    font-size: 10px;
    font-weight: 600;
    line-height: 15px;
    letter-spacing: 0;
    background: white;
    color: rgba(255, 69, 69, 1);
    padding: 0 8px;
}

.processing-payment {
    color: #627690;
    font-weight: 600;
    line-height: 13px;
    word-wrap: break-word;
    width: 100%;
    font-size: 10px;
}

.on-order-button {
    height: 24px;
    border-radius: 4px;
    border: 1px solid rgba(255, 165, 114, 1);
    font-size: 10px;
    font-weight: 600;
    line-height: 15px;
    letter-spacing: 0;
    text-align: left;
    background: white;
    color: rgba(255, 165, 114, 1);
    text-transform: uppercase;
    padding: 0 8px;
}

.to-pay-button {
    width: 53px;
    height: 24px;
    border-radius: 4px;
    border: 1px solid rgba(26, 160, 225, 1);
    font-size: 10px;
    font-weight: 600;
    line-height: 15px;
    letter-spacing: 0;
    text-align: left;
    background: white;
    color: rgba(26, 160, 225, 1);
    margin-top: 45px;
}

.to-pay-status {
    height: 24px;
    white-space: nowrap;
    border-radius: 4px;
    border: 1px solid var(--color-green);
    font-size: 10px;
    font-weight: 600;
    line-height: 15px;
    letter-spacing: 0;
    text-align: center;
    background: white;
    color: var(--color-green);
    margin-top: 15px;
    text-transform: uppercase;
}

.to-transport-button {
    //width: 93px;
    height: 24px;
    border-radius: 4px;
    border: 1px solid rgba(91, 114, 218, 1);
    font-size: 10px;
    font-weight: 600;
    line-height: 15px;
    letter-spacing: 0;
    text-align: left;
    background: white;
    color: rgba(26, 160, 225, 1);
    margin-top: 45px;
}

.dashboard__table-btn {
    text-wrap: nowrap;
}

.processing-documents-button {
    height: 25px;
    border-radius: 4px;
    border: 1px solid rgba(229, 182, 0, 1);
    font-size: 10px;
    font-weight: 600;
    line-height: 15px;
    letter-spacing: 0;
    text-align: left;
    background: white;
    color: rgba(229, 182, 0, 1);
    justify-content: center;
    align-items: center;
    display: inline-flex;
    text-transform: uppercase;
    white-space: nowrap;
    padding: 0 8px;
}

.processing-documents-details {
    font-size: 10px;
    font-weight: 400;
    line-height: 13px;
    letter-spacing: 0;
    text-align: left;
    color: rgba(98, 118, 144, 1);
    padding-top: 10px;
    width: 144px;
    height: 39px;
}
.vehicle-dashboard {
    width: 100%;
    height: 100%;
    background: rgba(228, 234, 240, 0.3);
    border-bottom: 1px #e4eaf0 solid;
    border-collapse: collapse;
}
.transport-status-container {
    width: 100%;
    height: 90%;
    padding: 1px;
    justify-content: flex-start;
    display: flex;
    padding-left: 20px;
}

.transport-status-button {
    color: #5b72da;
    background-color: white;
    font-size: 9px;
    font-weight: 600;
    text-transform: uppercase;
    white-space: nowrap;
    text-align: center;
    border-radius: 4px;
    border: 1px #5b72da solid;
    padding: 0 8px;
}
.completed-button {
    height: 24px;
    border-radius: 4px;
    border: 1px solid var(--color-green);
    font-size: 10px;
    font-weight: 600;
    line-height: 15px;
    letter-spacing: 0;
    text-align: left;
    background: white;
    color: var(--color-green);
    text-transform: uppercase;
    padding: 0 8px;
}

.progress-container {
    position: relative;
    width: 341px;
    height: 3px;
    background-color: rgba(98, 118, 144, 0.1);
    border-radius: 4px;
    overflow: hidden;
    margin-top: -5px;
}

.progress-bar {
    height: 100%;
    width: 0;
    background-color: #3498db;
    transition: width 0.3s ease;
}
.vehicle-checkbox {
    padding-left: c-rem(15);
    padding-right: c-rem(10);
    width: 1rem;
}
.order-info-label {
    font-size: c-rem(12);
}
.vehicle-column {
    min-height: 100%;
    height: 100%;
}
.car-preview-container {
    display: flex;
    position: relative;
    width: c-rem(250);
    height: 100%;
    background-color: rgba(237, 237, 237, 0.5);
    align-items: center;
    justify-content: center;
}
.no-image-block {
    background: var(--light-gray);
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.no-image-block.astara {
    background: #E4E4E4;
}
</style>
